import { EModalActionTypes } from './types';
import { actionGenerator } from '../../../../packages/redux-utils';

export const modalClose = actionGenerator(EModalActionTypes.ModalClose);
